import { defineMessages } from 'react-intl';

export const profileMessages = defineMessages({
    title: {
        id: 'profile-my-profile',
        defaultMessage: 'My profile',
    },
    details: {
        id: 'profile-details',
        defaultMessage: 'Details',
    },
    password: {
        id: 'profile-password',
        defaultMessage: 'Password',
    },
    settings: {
        id: 'profile-settings',
        defaultMessage: 'Settings',
    },
});

export const detailsMessages = defineMessages({
    personalInfoTitle: {
        id: 'profile-details-personal-info',
        defaultMessage: 'Personal info',
    },
    personalInfoSubtitle: {
        id: 'profile-details-personal-info-subtitle',
        defaultMessage: 'Update your name and email used across the system',
    },
    name: {
        id: 'profile-details-name',
        defaultMessage: 'Name',
    },
    nameSubtitle: {
        id: 'profile-details-name-subtitle',
        defaultMessage: 'Your name, used for identifying you across the system',
    },
    email: {
        id: 'profile-details-email',
        defaultMessage: 'Email',
    },
    emailSubtitle: {
        id: 'profile-details-email-subtitle',
        defaultMessage: 'The email you use to log in and receive system communication',
    },
    updateSuccess: {
        id: 'profile-details-update-success',
        defaultMessage: 'Profile updated',
    },
    updateSuccessDetails: {
        id: 'profile-details-update-success-details',
        defaultMessage: 'Your profile has been updated successfully',
    },
    accountInfoTitle: {
        id: 'profile-details-account-info',
        defaultMessage: 'Account info',
    },
    accountInfoSubtitle: {
        id: 'profile-details-account-info-subtitle',
        defaultMessage: 'Log out from your account on this device',
    },
    logout: {
        id: 'profile-details-logout',
        defaultMessage: 'Logout',
    },
});

export const passwordMessages = defineMessages({
    passwordTitle: {
        id: 'profile-password-title',
        defaultMessage: 'Password',
    },
    passwordSubtitle: {
        id: 'profile-password-subtitle',
        defaultMessage: 'Change the password used for logging into the system',
    },
    newPassword: {
        id: 'profile-password-new-password',
        defaultMessage: 'New password',
    },
    newPasswordSubtitle: {
        id: 'profile-password-new-password-subtitle',
        defaultMessage:
            'Your new password. Must be at least 8 characters and include lowercase, uppercase, a number and a special character.',
    },
    confirmNewPassword: {
        id: 'profile-password-confirm-new-password',
        defaultMessage: 'Confirm new password',
    },
    confirmNewPasswordSubtitle: {
        id: 'profile-password-confirm-new-password-subtitle',
        defaultMessage: 'Re-enter your new password',
    },
    passwordChangeSuccess: {
        id: 'profile-password-change-success',
        defaultMessage: 'Password changed',
    },
    passwordChangeSuccessDetails: {
        id: 'profile-password-change-success-details',
        defaultMessage: 'Your password has been changed successfully',
    },
});

export const settingsMessages = defineMessages({
    settingsTitle: {
        id: 'profile-settings-title',
        defaultMessage: 'Settings',
    },
    settingsSubtitle: {
        id: 'profile-settings-subtitle',
        defaultMessage: 'Change the settings for your account',
    },
    language: {
        id: 'profile-settings-language',
        defaultMessage: 'Language',
    },
    languageSubtitle: {
        id: 'profile-settings-language-subtitle',
        defaultMessage: 'Change the interface language',
    },
    changeLanguagePlaceholder: {
        id: 'profile-settings-change-language-placeholder',
        defaultMessage: 'Select language',
    },
});
